import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Page/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Privacy from "./Page/Privacy";
import Terms from "./Page/Terms";
import ScrollToTop from "./components/ScrollToTop";
import Blogs from "./Page/Blogs";
const App = () => {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/privacy-policy" element={<Privacy />}></Route>
          <Route path="/terms-and-conditions" element={<Terms />}></Route>
          <Route path="/blogs" element={<Blogs />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
